import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Optional,
  Output,
  ViewEncapsulation,
  OnDestroy
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BixiLayoutService } from '../layout.service';
import { IMenu } from '../layout.type';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'bixi-layout-menu',
  templateUrl: './menu.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  exportAs: 'bixiLayoutMenu',
  host: {
    class: 'bixi-layout-menu',
    '[class.bixi-layout-menu-collapsed]': '!open',
    '[class.bixi-layout-menu-opened]': 'open'
  }
})
export class BixiMenuComponent implements OnDestroy {
  @Input()
  set menus(menus: IMenu[]) {
    this._menus = menus;
    this.resume();
    this.openCurrentMenu();
  }
  get menus() {
    return this._menus;
  }
  @Output() menuClick = new EventEmitter<IMenu>();
  @Output() toggleClick = new EventEmitter<void>();
  @Input() singleOpen = false;
  @Input() menuBackground = '';
  subscription = new Subscription();
  _menus: IMenu[] = [];
  open = true;
  paddingLeft = 16;
  constructor(private router: Router, @Optional() private cdr: ChangeDetectorRef, private layoutService: BixiLayoutService) {
    this.subscription.add(
      this.layoutService.openChange.subscribe((open: boolean) => {
        this.open = open;
        if (this.cdr) {
          this.cdr.markForCheck();
        }
      })
    );

    // 切换路由
    this.subscription.add(
      this.router.events.pipe(
        filter(event => event instanceof NavigationEnd)
      ).subscribe(() => {
        this.openCurrentMenu();
      })
    );
  }

  onMenuClick(menuItem: IMenu) {
    this.menuClick.emit({ ...menuItem, selected: true });
  }

  openCurrentMenu() {
    const filterVisible = (menu: IMenu[]) => menu.filter(item => !(item.visible === false));
    const menus = filterVisible(this.menus.slice());
    const dealData = (dealMenus: IMenu[]): boolean | void => {
      for (const menu of dealMenus) {
        if (menu.children && menu.children.length > 0) {
          menu.children = filterVisible(menu.children);
          if (dealData(menu.children)) {
            menu.open = true;
            return true;
          } else {
            if (this.singleOpen) {
              menu.open = false;
            }
          }
        }

        if (menu.link && this.router.isActive(menu.link, !!menu.matchRouterExact)) {
          return true;
        }
      }
    };
    dealData(menus);
    this._menus = menus;
  }

  onOpenChange(open: boolean, curMenu: IMenu) {
    const menus = this.menus.slice();
    const dealData = (dealMenus: IMenu[]): boolean | void => {
      for (const menu of dealMenus) {
        if (menu._id === curMenu._id) {
          dealMenus
            .filter(item => item._id !== curMenu._id)
            .forEach(m => {
              m.open = false;
            });
          return true;
        }
        if (menu.children && menu.children.length > 0) {
          if (dealData(menu.children)) {
            return true;
          }
        }
      }
    };

    if (open && this.singleOpen) {
      dealData(menus);
      this._menus = menus;
    }
  }

  onToggleClick() {
    this.layoutService.toggleMenu();
    this.toggleClick.emit();
  }

  resume() {
    let i = 1;
    const setId = (menus: IMenu[]) => {
      for (const item of menus) {
        item._id = i++;
        if (item.children && item.children.length > 0) {
          setId(item.children);
        }
      }
    };
    setId(this._menus);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
